import { FC, Key } from 'react';
import { ProInput } from '../antd';
import SelectTable, { SelectTableProps } from '../SelectTable';
import SimpleFormDisabled from './subpage/disabled';
import SimpleFormItem from './subpage/simpleFormItem';
import { formatToEnumItem } from '../utils/utils';
import {
  BaseSimpleFormProps,
  SimpleFormItemEnum,
  DEFAULT_STYLE,
} from './interface';
import { NodeKey } from '../constants/interface';

export interface SimpleFormSelectTableProps extends BaseSimpleFormProps {
  namekey?: string;
  valuekey?: string;
  selectTableProps?: SelectTableProps;
}
const simpleFormSelectTable: FC<SimpleFormSelectTableProps> = props => {
  const { disabledRender, selectTableProps, form, name, ...restProps } = props;
  if (!selectTableProps) return null;
  let valueName: NodeKey | undefined = '';
  let labelName: NodeKey | undefined = '';
  if (Array.isArray(name)) {
    valueName = name[0];
    labelName = name[1];
  } else {
    valueName = name;
  }
  const handleBeforeFetch = (params: any) => {
    if (!selectTableProps.beforeFetch) return params;
    return (
      selectTableProps.beforeFetch?.(params, form?.getFieldsValue(true)) ||
      params
    );
  };
  const handleChange = (value: any, item: any, index?: number) => {
    if (selectTableProps.mode === 'multiple') {
      if (labelName)
        form?.setFieldsValue({
          [labelName]: item?.map((v: any) => v[selectTableProps.nameKey]),
        });
    } else {
      if (labelName)
        form?.setFieldsValue({
          [labelName]: item?.[0]?.[selectTableProps.nameKey],
        });
    }
    selectTableProps.onChange?.(value, item, form, index);
  };
  return (
    <>
      <SimpleFormItem {...restProps} name={valueName}>
        {selectTableProps?.disabled ? (
          <SimpleFormDisabled
            name={valueName}
            form={form}
            options={formatToEnumItem(
              selectTableProps.initOptions,
              selectTableProps.nameKey,
              selectTableProps.valueKey,
            )}
            render={disabledRender}
          />
        ) : (
          <SelectTable
            style={DEFAULT_STYLE}
            {...selectTableProps}
            beforeFetch={handleBeforeFetch}
            // @ts-ignore
            onChange={handleChange}
          />
        )}
      </SimpleFormItem>
      {!!labelName && (
        <SimpleFormItem
          hidden={true}
          name={labelName}
          style={{ padding: 0, margin: 0 }}
        >
          <ProInput />
        </SimpleFormItem>
      )}
    </>
  );
};

simpleFormSelectTable.displayName = SimpleFormItemEnum.SimpleFormSelectTable;

export default simpleFormSelectTable;
